<!-- *operation btns -->
<div app-menu-btn [matMenuTriggerFor]="menuLevel" [isShowDotsMenu]="true"></div>

<mat-menu #menuLevel="matMenu" xPosition="before">
  @for (menuItem of matMenuItems; track $index) {
  <div
    *ngIf="menuItem.condition()"
    mat-menu-item
    class="!tw-flex-center border-bottom"
    [class]="menuItem.color"
    (click)="onOperation(menuItem.operation)"
  >
    <i
      class="mdi tw-ml-[10px] ltr:tw-mr-[10px]"
      [class]="menuItem.iconClass"
    ></i>
    <span class="mat-menu-title tw-font-medium">{{
     'common.'+menuItem.label | translate
    }}</span>
  </div>
  }
</mat-menu>
